"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";
import AppImage from "@/components/ui/AppImage";

const products = [
{
  id: "laundry-detergent",
  name: "濃縮洗衣液",
  nameEn: "Concentrated Laundry Detergent",
  category: "清潔用品",
  price: "HK$ 38",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_161cd55de-1765097404009.png",
  alt: "濃縮洗衣液產品圖，藍色瓶裝，乾淨整潔的展示",
  tags: ["暢銷", "批發優惠"],
  col: "col-span-1 row-span-1"
},
{
  id: "dish-soap",
  name: "天然洗碗液",
  nameEn: "Natural Dish Soap",
  category: "清潔用品",
  price: "HK$ 28",
  img: "https://images.unsplash.com/photo-1642505173156-e5ff10af9da6",
  alt: "天然洗碗液，綠色環保包裝，柑橘香型",
  tags: ["天然配方"],
  col: "col-span-1 row-span-2"
},
{
  id: "shampoo",
  name: "滋養洗髮水",
  nameEn: "Nourishing Shampoo",
  category: "個人護理",
  price: "HK$ 52",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1d75b9cbd-1765173220232.png",
  alt: "滋養洗髮水，白色優雅瓶裝，護髮系列",
  tags: ["新品"],
  col: "col-span-1 row-span-1"
},
{
  id: "kitchen-cleaner",
  name: "廚房多功能清潔劑",
  nameEn: "Kitchen Multi-Purpose Cleaner",
  category: "廚房用品",
  price: "HK$ 45",
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_10de60a26-1765801878220.png",
  alt: "廚房多功能清潔劑噴霧瓶，適用於各種廚房表面",
  tags: ["熱銷"],
  col: "col-span-2 row-span-1"
}];


export default function FeaturedProducts() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    );
    const els = sectionRef?.current?.querySelectorAll(".reveal-hidden");
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24">
      <div className="container-main">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 reveal-hidden">
          <div>
            <span className="text-xs text-gold-DEFAULT uppercase tracking-widest font-semibold">精選產品</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mt-2">
              熱門商品推介
            </h2>
            <p className="text-white/50 mt-3 max-w-md">
              精心挑選的優質日用品，適合零售商及批發採購
            </p>
          </div>
          <Link href="/products" className="btn-gold-outline px-6 py-3 rounded-lg text-sm font-semibold whitespace-nowrap self-start md:self-auto">
            查看全部產品 →
          </Link>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
          {products?.map((p, i) =>
          <Link
            key={p?.id}
            href={`/product-detail?id=${p?.id}`}
            className={`product-card reveal-hidden delay-${i + 1} ${
            i === 3 ? "sm:col-span-2 md:col-span-2" : ""} ${
            i === 1 ? "sm:row-span-2 md:row-span-2" : ""}`}>
            
              <div className={`relative overflow-hidden ${
                i === 1 ? "h-64 sm:h-72 md:h-full" : "h-56 sm:h-52"
              }`}>
                <AppImage
                src={p?.img}
                alt={p?.alt}
                fill
                className="object-cover product-img" />
              
                <div className="img-overlay absolute inset-0" />
                {/* Tags */}
                <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap max-w-[calc(100%-24px)]">
                  {p?.tags?.map((tag) =>
                <span key={tag} className="category-badge text-[10px] sm:text-[11px] px-2.5 py-1 rounded-full font-medium">
                      {tag}
                    </span>
                )}
                </div>
              </div>
              <div className="p-4 sm:p-5">
                <p className="text-[11px] text-white/40 uppercase tracking-wider mb-1.5">{p?.category}</p>
                <h3 className="font-serif text-lg sm:text-xl text-white font-semibold mb-1 leading-tight">{p?.name}</h3>
                <p className="text-xs sm:text-sm text-white/40 mb-3 sm:mb-4">{p?.nameEn}</p>
                <div className="flex items-center justify-between">
                  <span className="text-gold-DEFAULT font-bold text-base sm:text-lg">{p?.price}</span>
                  <span className="text-xs sm:text-sm text-white/30 hover:text-white transition-colors">查看詳情 →</span>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    </section>);

}